export default {
    submitcancelform: {
        cancel: 'Отменить',
        close: 'Закрыть',
        next: 'Далее',
        submit: 'Сохранить',
    },
}